import { useMemo } from "react";

import { type DSSCalendarEvent } from "./DSSCalendar.types";
import { filterEventsByMonth } from "./DSSCalendar.utils";
import { mockEvents } from "./mockEvents";

interface UseDSSCalendarEventsResult {
  events: DSSCalendarEvent[];
  isLoading: boolean;
}

export const useDSSCalendarEvents = (
  month: string,
): UseDSSCalendarEventsResult => {
  // v2: replace with useGetApi({ request: "<endpoint>", body: { params: { month, yachtid } } })
  const events = useMemo(() => filterEventsByMonth(mockEvents, month), [month]);

  return {
    events,
    isLoading: false,
  };
};
